
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import { InfoFilled } from "@element-plus/icons-vue";
import { ElConfigProvider } from "element-plus";
//中文包
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getMenuList, delMenuList } from "@/api/backstage";
import { MenuModel } from "@/model/menuModel";
import { getEnum } from "@/api/index";
import Edit from "./Edit.vue";
import { ElForm } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "菜单管理",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    Edit,
  },
  setup() {
    let locale = zhCn;
    const store = useStore();
    const ruleFormRef = ref(ElForm);
    const dataMap: any = reactive({
       filurl:localStorage.getItem('fileUrel'),
      ruleFormRef: ref<FormInstance>(),
      dialogVisible: false,
      rows:'',
      tableData: [],
      menuType: {},
      menuClass: {},
      total: 0,
      form: {
        name: "",
        menuType: "",
        classfier: "",
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        const data = await getMenuList(this.form);
        for(const item of data.data.list){
          if(item.files){
            item.fileUrl =  localStorage.getItem("fileUrel") + item.files[0].fileName;
          }
        }
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },
      async getMenuType() {
        dataMap.menuType = {};
        const menus = await getEnum("MENU_TYPE");
        for (const item of menus.data) {
          dataMap.menuType[item.enumKey] = item;
        }
        store.dispatch("asyncMenuType", dataMap.menuType);
      },
      async getMenuClass() {
        dataMap.menuClass = {};
        const menus = await getEnum("MENU_CLASSFIER");
        for (const item of menus.data) {
          dataMap.menuClass[item.enumKey] = item;
        }
        store.dispatch("asyncMenuClass", dataMap.menuClass);
      },
      async delMenu(ids: any) {
        const baseId = { id: ids };
        const res = await delMenuList(baseId);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });
    const onSubmit = () => {
      dataMap.getList();
    };
    const editClick = (row: any) => {
      dataMap.dialogVisible = true;
      dataMap.rows = row;
    };
    const addClick = (row: any) => {
      dataMap.dialogVisible = true;
      dataMap.rows = '';
    };
    const close = (val: any) => {
      dataMap.dialogVisible = false;
      dataMap.getList();
    };
    const confirmEvent = (row: any, index: any) => {
      dataMap.delMenu(row.id);
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataMap.getList();
    };
    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };

    onMounted(() => {
      dataMap.getList();
      dataMap.getMenuType();
      dataMap.getMenuClass(); 
    });

    return {
      locale,
      onSubmit,
      resetForm,
      close,
      editClick,
      addClick,
      handleSizeChange,
      handleCurrentChange,
      confirmEvent,
      ...toRefs(dataMap),
    };
  },
});
